import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { Record } from 'immutable';

import t from '../../lib/I18n';
import config from '../../config';

import ValidatedFormField from '../form/ValidatedField';
import Accordion from '../general/Accordion';
import FormattedHTMLMessage from '../general/FormattedHTMLMessage';
import ExternalLink from '../general/ExternalLink';

export const TermsAndConditionsLink = ({ className, message = t('form.termsAndConditions') }) => (
    <ExternalLink className={ className } message={ message } href={ config.get('legalUrl') } />
);

export const PrivacyPolicyLink = ({ className, message = t('form.privacyPolicy') }) => (
    <ExternalLink className={ className } message={ message } href={ config.get('privacyPolicyUrl') } />
);

const termsPrivacySharedPropTypes = {
    message: PropTypes.string.isRequired,
    className: PropTypes.string,
};
TermsAndConditionsLink.propTypes = termsPrivacySharedPropTypes;
PrivacyPolicyLink.propTypes = termsPrivacySharedPropTypes;

export default function SignupTAndCs ({ form, visited, onToggle }) {
    return (
        <div>
            <div className="margin-bottom--sm">
                <ValidatedFormField
                    form={ form }
                    visited={ visited }
                    field="acceptedTAndCs"
                    checked={ form.get('acceptedTAndCs') }
                    type="checkbox"
                    onChange={ onToggle }
                    label={
                        <FormattedHTMLMessage
                            message='preference-centre.terms-and-conditions.warning'
                            termsAndConditions={ <TermsAndConditionsLink /> }
                        />
                    }
                    externalFormGroup
                />
            </div>
            <div className="margin-bottom">
                <FormattedHTMLMessage className="text-sm" message='preference-centre.privacy-notice' />
                { t('preference-centre.privacy-notice.more').length > 1 && (
                    <Accordion singleUse>
                        <FormattedHTMLMessage className="text-sm" message='preference-centre.privacy-notice.more' />
                    </Accordion>
                ) }
            </div>
        </div>
    );
}

SignupTAndCs.propTypes = {
    form: PropTypes.instanceOf(Record).isRequired,
    visited: PropTypes.bool,
    onToggle: PropTypes.func
};

SignupTAndCs.defaultProps = {
    visited: false,
    onToggle: _.noop
};



// WEBPACK FOOTER //
// ./src/components/customer/SignupTAndCs.js